import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Create axios instance
const api = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add a request interceptor to include JWT token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle 401 errors (token expired)
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Auto logout if 401 response returned from api
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Authentication API calls
export const loginUser = async (credentials) => {
    console.log(`${API_URL}/users/auth/login`);

    const response = await api.post(`${API_URL}/users/auth/login`, credentials);
    return response.data;
};

// User CRUD operations
export const getUsers = async () => {
    const response = await api.get(`${API_URL}/users`);
    return response.data;
};

export const getUserById = async (id) => {
    const response = await api.get(`${API_URL}/users/${id}`);
    return response.data;
};

export const createUser = async (userData) => {
    const response = await api.post(`${API_URL}/users`, userData);
    return response.data;
};

export const updateUser = async (id, userData) => {
    const response = await api.put(`${API_URL}/users/${id}`, userData);
    return response.data;
};

export const deleteUser = async (id) => {
    const response = await api.delete(`${API_URL}/users/${id}`);
    return response.data;
};
